const countryFlags = {
    "France": "🇫🇷",
    "USA": "🇺🇸",
    "Australia": "🇦🇺",
    "Spain": "🇪🇸",
    "Country": "🏳️"
};

module.exports = {
    countryFlags
};
